'use client';

import { useState, useEffect } from 'react';
import moment from 'moment';

import CompactSidebarFilter from '../../../utils/Compact-Sidebar-Filter';
import EditModal from '../../../utils/Compact-Edit_modal';
import SmartPagination from '../../../utils/Smart-Pagination';

const EnhancedActivityCyclesSection = ({
  SIDEBAR_OPTIONS,
  dropdownOptions,
  loadOptions,
  total_activitycycles,
  activitycycles,
  activitycycles_loading,
  page,
  pages,
  setPageNumber,
  LIMIT,
  deleteBtnClicked,
  updateStatus,
  setModal,
  setModalData,
  setActivity,
  setAcvtivityCycle,
  loadingActivityStatus,
  reloadData,
  LINK_URL,
  PAGE_SINGLE_TITLE,
  Pagination,
  AddBtn,
  Spinner,
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);

  // Load saved sidebar state
  useEffect(() => {
    const savedSidebarState = localStorage.getItem(
      'activity-cycles-sidebar-collapsed'
    );
    if (savedSidebarState) {
      setSidebarCollapsed(JSON.parse(savedSidebarState));
    }
  }, []);

  // Save sidebar state to localStorage
  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem(
      'activity-cycles-sidebar-collapsed',
      JSON.stringify(newState)
    );
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      COMPLETED: 'badge bg-success',
      PENDING: 'badge bg-warning text-dark',
      OVERDUE: 'badge bg-danger',
    };
    return statusClasses[status] || 'badge bg-light text-dark';
  };

  const handleEdit = (cycleId, field, currentValue, fieldLabel, single) => {
    setEditData({ billId: cycleId, field, currentValue, fieldLabel, single });
    setShowEditModal(true);
  };

  const handleSaveEdit = async (cycleId, field, value) => {
    const newValues = { [field]: value };
    await updateStatus(cycleId, newValues);
    setShowEditModal(false);
    setEditData(null);
  };

  const isOverdue = (single) => {
    return (
      single.status &&
      single.status !== 'COMPLETED' &&
      moment().diff(moment(single.due_time).utc(), 'hours') > 0
    );
  };

  return (
    <div className='container-fluid'>
      <div className='row'>
        {/* Collapsible Sidebar */}
        {SIDEBAR_OPTIONS && (
          <div
            className={`${
              sidebarCollapsed ? 'd-none' : 'col-xl-2 col-lg-3'
            } transition-all`}
            style={{
              transition: 'all 0.3s ease-in-out',
            }}
          >
            <CompactSidebarFilter
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
              dropdown_options={dropdownOptions}
              loadOptions={loadOptions}
              col={2}
            />
          </div>
        )}

        {/* Main Activity Cycles Section */}
        <div
          className={`${
            sidebarCollapsed ? 'col-lg-12' : 'col-xl-10 col-lg-9'
          } transition-all`}
        >
          <div className='card shadow-sm border-0'>
            {/* Enhanced Header with Sidebar Toggle */}
            <div className='card-header bg-white border-bottom py-3'>
              <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                  {/* Sidebar Toggle Button */}
                  <button
                    className='btn btn-outline-secondary btn-sm me-3'
                    onClick={toggleSidebar}
                    title={sidebarCollapsed ? 'Show Filters' : 'Hide Filters'}
                    style={{
                      fontSize: '12px',
                      padding: '6px 10px',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <i
                      className={`fa ${
                        sidebarCollapsed ? 'fa-filter' : 'fa-times'
                      } me-1`}
                      style={{ fontSize: '11px' }}
                    ></i>
                    {sidebarCollapsed ? 'Show Filters' : 'Hide Filters'}
                  </button>
                  <h5 className='mb-0 text-dark'>Activity Cycles Management</h5>
                </div>
                <div className='d-flex align-items-center gap-2'>
                  <a
                    className='btn btn-danger btn-sm'
                    href={`/activity-cycles?conditional[due_time][$lt]=${moment()
                      .utc()
                      .format('YYYY-MM-DD')}&exact[status]=PENDING`}
                    style={{ fontSize: '12px', padding: '6px 12px' }}
                  >
                    <i
                      className='fa fa-exclamation-triangle me-1'
                      style={{ fontSize: '11px' }}
                    ></i>
                    Overdue Activity Cycles
                  </a>
                  <a
                    className='btn btn-warning btn-sm'
                    href='/activity-cycles/add-calendar'
                    style={{ fontSize: '12px', padding: '6px 12px' }}
                  >
                    <i
                      className='fa fa-calendar-plus me-1'
                      style={{ fontSize: '11px' }}
                    ></i>
                    Add Calendar
                  </a>
                  <AddBtn item={LINK_URL} title={PAGE_SINGLE_TITLE} />
                </div>
              </div>
            </div>

            {/* Activity Cycles Summary Header */}
            <div className='card-body border-bottom bg-light py-3'>
              <div className='row g-3'>
                {/* Total Activity Cycles */}
                <div className='col-lg-3 col-md-6'>
                  <div className='d-flex align-items-center'>
                    <div
                      className='flex-shrink-0 me-3'
                      style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#e3f2fd',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='fa fa-sync-alt text-primary'
                        style={{ fontSize: '16px' }}
                      ></i>
                    </div>
                    <div>
                      <div
                        className='text-muted mb-1'
                        style={{ fontSize: '11px', fontWeight: '500' }}
                      >
                        TOTAL CYCLES
                      </div>
                      <div
                        className='fw-bold text-dark'
                        style={{ fontSize: '18px' }}
                      >
                        {total_activitycycles?.toLocaleString('en-IN') || 0}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pending Cycles */}
                <div className='col-lg-3 col-md-6'>
                  <div className='d-flex align-items-center'>
                    <div
                      className='flex-shrink-0 me-3'
                      style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#fff3e0',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='fa fa-clock text-warning'
                        style={{ fontSize: '16px' }}
                      ></i>
                    </div>
                    <div>
                      <div
                        className='text-muted mb-1'
                        style={{ fontSize: '11px', fontWeight: '500' }}
                      >
                        PENDING
                      </div>
                      <div
                        className='fw-bold text-warning'
                        style={{ fontSize: '18px' }}
                      >
                        {activitycycles?.filter(
                          (cycle) => cycle.status === 'PENDING'
                        )?.length || 0}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Completed Cycles */}
                <div className='col-lg-3 col-md-6'>
                  <div className='d-flex align-items-center'>
                    <div
                      className='flex-shrink-0 me-3'
                      style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#e8f5e8',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='fa fa-check-circle text-success'
                        style={{ fontSize: '16px' }}
                      ></i>
                    </div>
                    <div>
                      <div
                        className='text-muted mb-1'
                        style={{ fontSize: '11px', fontWeight: '500' }}
                      >
                        COMPLETED
                      </div>
                      <div
                        className='fw-bold text-success'
                        style={{ fontSize: '18px' }}
                      >
                        {activitycycles?.filter(
                          (cycle) => cycle.status === 'COMPLETED'
                        )?.length || 0}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Overdue Cycles */}
                <div className='col-lg-3 col-md-6'>
                  <div className='d-flex align-items-center'>
                    <div
                      className='flex-shrink-0 me-3'
                      style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#ffebee',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='fa fa-exclamation-triangle text-danger'
                        style={{ fontSize: '16px' }}
                      ></i>
                    </div>
                    <div>
                      <div
                        className='text-muted mb-1'
                        style={{ fontSize: '11px', fontWeight: '500' }}
                      >
                        OVERDUE
                      </div>
                      <div
                        className='fw-bold text-danger'
                        style={{ fontSize: '18px' }}
                      >
                        {activitycycles?.filter((cycle) => isOverdue(cycle))
                          ?.length || 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {sidebarCollapsed && (
                <div className='mt-3'>
                  <div
                    className='alert alert-info py-2 mb-0'
                    style={{ fontSize: '12px' }}
                  >
                    <i className='fa fa-info-circle me-2'></i>
                    Sidebar is hidden - Full width view enabled for better data
                    visibility
                  </div>
                </div>
              )}
            </div>

            <div className='card-body pt-0'>
              {/* Records Count */}
              <div className='d-flex justify-content-between align-items-center mb-3 mt-3'>
                <div
                  className='text-muted'
                  style={{ fontSize: '12px', fontWeight: '500' }}
                >
                  <i
                    className='fa fa-list me-2'
                    style={{ fontSize: '11px' }}
                  ></i>
                  {total_activitycycles} records found
                  {sidebarCollapsed && (
                    <span
                      className='badge bg-info ms-2'
                      style={{ fontSize: '10px' }}
                    >
                      <i className='fa fa-expand-arrows-alt me-1'></i>
                      Full Width
                    </span>
                  )}
                </div>
              </div>

              {/* Enhanced Activity Cycles Table */}
              <div
                className='table-responsive'
                style={{
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: '75vh',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                }}
              >
                <table
                  className='table table-hover align-middle'
                  style={{
                    tableLayout: 'fixed',
                    minWidth: '1200px',
                    border: '1px solid #e9ecef',
                  }}
                >
                  {!activitycycles_loading && (
                    <thead>
                      <tr
                        className='table-light'
                        style={{ borderBottom: '2px solid #dee2e6' }}
                      >
                        <th
                          className='border-end py-3 text-center'
                          style={{
                            width: '60px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>#</span>
                        </th>
                        <th
                          className='border-end py-3'
                          style={{
                            width: '200px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>NAME</span>
                        </th>
                        <th
                          className='border-end py-3'
                          style={{
                            width: '180px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>CLIENT</span>
                        </th>
                        <th
                          className='border-end py-3'
                          style={{
                            width: '200px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>DUE TIME</span>
                        </th>
                        <th
                          className='border-end py-3'
                          style={{
                            width: '180px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>PROCESS</span>
                        </th>
                        <th
                          className='border-end py-3'
                          style={{
                            width: '140px',
                            fontSize: '11px',
                            fontWeight: '600',
                            borderRight: '1px solid #e9ecef',
                          }}
                        >
                          <span className='text-muted'>STATUS</span>
                        </th>
                        <th
                          className='py-3 text-center'
                          style={{
                            position: 'sticky',
                            right: 0,
                            backgroundColor: '#f8f9fa',
                            borderLeft: '1px solid #dee2e6',
                            boxShadow: '-2px 0 4px rgba(0,0,0,0.05)',
                            zIndex: 5,
                            width: '100px',
                            minWidth: '100px',
                            fontSize: '11px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span className='text-muted'>ACTIONS</span>
                        </th>
                      </tr>
                    </thead>
                  )}

                  <tbody>
                    {!activitycycles_loading ? (
                      activitycycles &&
                      activitycycles.map((single, index) => {
                        const overdueStatus = isOverdue(single);

                        return (
                          <tr
                            key={single._id}
                            className={
                              overdueStatus
                                ? 'table-danger table-danger-subtle'
                                : ''
                            }
                            style={{ borderBottom: '1px solid #f8f9fa' }}
                          >
                            {/* Serial Number */}
                            <td
                              className='border-end py-3 text-center'
                              style={{
                                borderRight: '1px solid #f8f9fa',
                                width: '60px',
                              }}
                            >
                              <span
                                className='badge bg-light text-dark'
                                style={{
                                  fontSize: '11px',
                                  fontWeight: '600',
                                }}
                              >
                                {index + 1 + (page - 1) * LIMIT}
                              </span>
                            </td>

                            {/* Name */}
                            <td
                              className='border-end py-3'
                              style={{
                                width: '200px',
                                borderRight: '1px solid #f8f9fa',
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <div className='d-flex align-items-center justify-content-between'>
                                <div
                                  className='text-truncate me-2'
                                  title={single.name}
                                >
                                  <span
                                    style={{
                                      fontSize: '13px',
                                      fontWeight: '500',
                                      color: '#212529',
                                    }}
                                  >
                                    {single.name}
                                  </span>
                                </div>
                                <button
                                  className='btn btn-link btn-sm p-1 text-muted flex-shrink-0'
                                  onClick={() =>
                                    handleEdit(
                                      single._id,
                                      'name',
                                      single.name,
                                      'Name',
                                      single
                                    )
                                  }
                                  title='Edit Name'
                                  style={{ fontSize: '11px' }}
                                >
                                  <i className='fa fa-edit'></i>
                                </button>
                              </div>
                            </td>

                            {/* Client */}
                            <td
                              className='border-end py-3'
                              style={{
                                width: '180px',
                                borderRight: '1px solid #f8f9fa',
                                maxWidth: '180px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <div className='d-flex align-items-center justify-content-between'>
                                <div
                                  className='text-truncate me-2'
                                  title={single.client?.name}
                                >
                                  <span
                                    style={{
                                      fontSize: '13px',
                                      fontWeight: '500',
                                      color: '#212529',
                                    }}
                                  >
                                    {single.client?.name}
                                  </span>
                                </div>
                                <button
                                  className='btn btn-link btn-sm p-1 text-muted flex-shrink-0'
                                  onClick={() =>
                                    handleEdit(
                                      single._id,
                                      'client',
                                      single.client?._id,
                                      'Client',
                                      single
                                    )
                                  }
                                  title='Edit Client'
                                  style={{ fontSize: '11px' }}
                                >
                                  <i className='fa fa-edit'></i>
                                </button>
                              </div>
                            </td>

                            {/* Due Time */}
                            <td
                              className='border-end py-3'
                              style={{
                                width: '200px',
                                borderRight: '1px solid #f8f9fa',
                              }}
                            >
                              <div className='d-flex align-items-center justify-content-between'>
                                <div>
                                  <div
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: '500',
                                      color: '#212529',
                                    }}
                                  >
                                    {single.due_time &&
                                      moment(single.due_time)
                                        .utc()
                                        .format('DD-MM-YYYY')}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: '11px',
                                      color: '#6c757d',
                                    }}
                                  >
                                    {single.due_time &&
                                      moment(single.due_time)
                                        .utc()
                                        .format('hh:mm A')}
                                  </div>
                                  {overdueStatus && (
                                    <div className='mt-1'>
                                      <span
                                        className='badge bg-danger'
                                        style={{ fontSize: '10px' }}
                                      >
                                        <i
                                          className='fa fa-exclamation-triangle me-1'
                                          style={{ fontSize: '9px' }}
                                        ></i>
                                        Overdue
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <button
                                  className='btn btn-link btn-sm p-1 text-muted flex-shrink-0'
                                  onClick={() =>
                                    handleEdit(
                                      single._id,
                                      'due_time',
                                      moment(single.due_time).format(
                                        'YYYY-MM-DDTHH:mm'
                                      ),
                                      'Due Time',
                                      single
                                    )
                                  }
                                  title='Edit Due Time'
                                  style={{ fontSize: '11px' }}
                                >
                                  <i className='fa fa-edit'></i>
                                </button>
                              </div>
                            </td>

                            {/* Process */}
                            <td
                              className='border-end py-3'
                              style={{
                                width: '180px',
                                borderRight: '1px solid #f8f9fa',
                                maxWidth: '180px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <div className='d-flex align-items-center justify-content-between'>
                                <div
                                  className='text-truncate me-2'
                                  title={single.process?.name}
                                >
                                  <span
                                    style={{
                                      fontSize: '13px',
                                      fontWeight: '500',
                                      color: '#495057',
                                    }}
                                  >
                                    {single.process?.name}
                                  </span>
                                </div>
                                <button
                                  className='btn btn-link btn-sm p-1 text-muted flex-shrink-0'
                                  onClick={() =>
                                    handleEdit(
                                      single._id,
                                      'process',
                                      single.process?._id,
                                      'Process',
                                      single
                                    )
                                  }
                                  title='Edit Process'
                                  style={{ fontSize: '11px' }}
                                >
                                  <i className='fa fa-edit'></i>
                                </button>
                              </div>
                            </td>

                            {/* Status */}
                            <td
                              className='border-end py-3'
                              style={{
                                width: '140px',
                                borderRight: '1px solid #f8f9fa',
                              }}
                            >
                              <div className='d-flex align-items-center justify-content-between'>
                                <span
                                  className={getStatusBadge(single.status)}
                                  style={{
                                    fontSize: '10px',
                                    fontWeight: '500',
                                  }}
                                >
                                  {single.status}
                                </span>
                                <button
                                  className='btn btn-link btn-sm p-1 text-muted flex-shrink-0'
                                  onClick={() =>
                                    handleEdit(
                                      single._id,
                                      'status',
                                      single.status,
                                      'Status',
                                      single
                                    )
                                  }
                                  title='Edit Status'
                                  style={{ fontSize: '11px' }}
                                >
                                  <i className='fa fa-edit'></i>
                                </button>
                              </div>
                            </td>

                            {/* Actions */}
                            <td
                              className='py-3 text-center'
                              style={{
                                position: 'sticky',
                                right: 0,
                                backgroundColor: '#ffffff',
                                borderLeft: '1px solid #dee2e6',
                                boxShadow: '-2px 0 4px rgba(0,0,0,0.05)',
                                zIndex: 5,
                                width: '100px',
                                minWidth: '100px',
                              }}
                            >
                              <div className='d-flex justify-content-center align-items-center gap-1'>
                                <button
                                  className='btn btn-outline-info btn-sm'
                                  onClick={() => {
                                    setModal(true);
                                    setModalData(single);
                                    setActivity(single._id);
                                    setAcvtivityCycle(single._id);
                                  }}
                                  title='View Details'
                                  style={{
                                    fontSize: '4px',
                                    padding: '4px 6px',
                                    minWidth: '28px',
                                    height: '24px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  <i
                                    className='fa fa-binoculars'
                                    style={{ fontSize: '10px' }}
                                  ></i>
                                </button>
                                <button
                                  className='btn btn-outline-danger btn-sm'
                                  onClick={() => deleteBtnClicked(single._id)}
                                  title='Delete'
                                  style={{
                                    fontSize: '4px',
                                    padding: '4px 6px',
                                    minWidth: '28px',
                                    height: '24px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  <i
                                    className='fa fa-trash'
                                    style={{ fontSize: '10px' }}
                                  ></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={7} className='text-center py-5'>
                          <div className='d-flex flex-column align-items-center'>
                            <Spinner />
                            <div
                              className='text-muted mt-3'
                              style={{ fontSize: '13px' }}
                            >
                              Loading activity cycles...
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <SmartPagination
                page={page}
                pages={pages}
                total_count={total_activitycycles}
                setPageNumber={setPageNumber}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <EditModal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setEditData(null);
        }}
        editData={editData}
        dropdownOptions={{
          ...dropdownOptions,
          status: [
            { value: 'PENDING', label: 'PENDING' },
            { value: 'COMPLETED', label: 'COMPLETED' },
          ],
        }}
        onSave={handleSaveEdit}
        loading={loadingActivityStatus}
      />
    </div>
  );
};

export default EnhancedActivityCyclesSection;
